import { render, staticRenderFns } from "./TAFooter.vue?vue&type=template&id=1f8f327a&scoped=true&"
import script from "./TAFooter.vue?vue&type=script&lang=js&"
export * from "./TAFooter.vue?vue&type=script&lang=js&"
import style1 from "./TAFooter.vue?vue&type=style&index=1&id=1f8f327a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8f327a",
  null
  
)

export default component.exports